module.exports = __webpack_public_path__ + "resources/icon-letter-head-open.194096db8f37ad2e.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-rolling/img/icon-letter-head-open.png
// module id = 826
// module chunks = 0 1